class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    try {
      const serializedValue =
        typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
      window.dispatchEvent(new Event('localStorageChange'));
    } catch (error) {
      console.error(`Error setting item ${key} in localStorage`, error);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const serializedValue = localStorage.getItem(key);
      if (serializedValue === null) return null;

      try {
        const parsed = JSON.parse(serializedValue) as T;
        if (typeof parsed === 'string') {
          return parsed;
        }
        return parsed;
      } catch {
        // GoodLoka stocke le JWT en brut (sans JSON.stringify)
        return serializedValue as T;
      }
    } catch (error) {
      console.error(`Error getting item ${key} from localStorage`, error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item ${key} from localStorage`, error);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage', error);
    }
  }
}

export const localStorageService = new LocalStorageService();

/** Token JWT GoodLoka / Faritany (compatible stockage brut ou JSON). */
export const getAuthToken = (): string | null =>
  localStorageService.getItem<string>('token');

export const setAuthToken = (token: string): void => {
  localStorageService.setItem('token', token);
};
